import { useContext } from 'react'
import WebSocketContext from '../contexts/WebSocketContext'

const useWebSocket = () => useContext(WebSocketContext)

export default useWebSocket